module.exports = __webpack_public_path__ + "static/media/44516085_2199892793419233_4464046547692158976_o-thumb.77781050.jpg";